import { ROUTER_NAME_HOME } from '@/features/home/home.router';
import { ROUTE_NAME_MIDDLE_LOGOUT } from '@/features/middle-page-logout/middle-page-logout.router';
import { ROUTE_NAME_MIDDLE_NETWORK_ERROR } from '@/features/middle-page-network-error/middle-page-network-error.router';
import { RouteRecordName } from 'vue-router';

// 定义无需校验登录信息的路由名
const whiteRouterNames = [ROUTER_NAME_HOME, ROUTE_NAME_MIDDLE_LOGOUT, ROUTE_NAME_MIDDLE_NETWORK_ERROR];

/**
 * 判断当前路由是否需要登录状态
 *
 * @param routeName 路由名称
 */
export function isWhiteUrl(routeName?: RouteRecordName | null) {
  // 暂时不考虑symbol类型的路由
  if (!routeName || typeof routeName === 'symbol') {
    return false;
  }
  return whiteRouterNames?.indexOf(routeName) !== -1;
}
